export default __webpack_public_path__ + "static/media/sports08.41e4b4d6.png";